// Route: /materials/sets/[id] — LEGACY redirect → /collections/[id].
//
// «Наборы» переименованы в «Коллекции» (под-фаза 1 Collections). Канонический
// роут — /collections/$setId. Старые ссылки/закладки/deep-links не должны
// ломаться: redirect с прокидкой params.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/materials/sets/$setId")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/library/folders/$folderId",
			params: { folderId: params.setId },
			replace: true,
		});
	},
});
